/** Type of favorite object in favorites informer block */
export enum FavoriteInformerTypeEnum {
  /** Favorite project */
  PROJECT = 'PROJECT',
  /** Favorite HelpDesk task */
  HD_TASK = 'HD_TASK',
}
